import { Injectable } from '@angular/core';
import { Observable, of, shareReplay, tap } from 'rxjs';

import { ApiResponses, BackendService } from './backend.service';
import { JwtService } from './jwt.service';

type UserMeasures = ApiResponses['user/getMeasures'];

@Injectable({ providedIn: 'root' })
export class UserMeasuresService {
  private cachedMeasures: UserMeasures | null = null;
  private load$?: Observable<UserMeasures>;

  constructor(
    private readonly backendService: BackendService,
    private readonly jwtService: JwtService
  ) {
    this.jwtService.$loginChange.subscribe(({ userdata }) => {
      if (userdata) this.refresh();
      else this.clear();
    });

    if (this.jwtService.isLoggedIn) this.refresh();
  }

  get equipmentClassId(): number | null | undefined {
    return this.cachedMeasures?.equipmentClassId ?? null;
  }

  ensureLoaded(): Observable<UserMeasures> {
    if (this.cachedMeasures) return of(this.cachedMeasures);
    if (this.load$) return this.load$;

    this.load$ = this.backendService.get<'user/getMeasures'>('user/measures').pipe(
      tap((measures) => {
        this.cachedMeasures = measures;
      }),
      shareReplay(1)
    );

    return this.load$;
  }

  refresh(): void {
    this.cachedMeasures = null;
    this.load$ = undefined;
    if (this.jwtService.isLoggedIn) {
      this.ensureLoaded().subscribe();
    }
  }

  clear(): void {
    this.cachedMeasures = null;
    this.load$ = undefined;
  }
}
